import { getThemeCopy } from '@/utils/theme';

/** 进入页付款账号弹窗：主题有文案则使用主题文案，其他主题走默认 i18n */
export default {
  computed: {
    paymentAccountPopupWarningCopy() {
      return getThemeCopy('paymentAccountPopup.warning', this.$i18n.locale);
    },
    paymentAccountPopupSubmitCopy() {
      return getThemeCopy('paymentAccountPopup.submit', this.$i18n.locale);
    },
    paymentAccountPopupInputPlaceholderCopy() {
      return getThemeCopy('paymentAccountPopup.inputPlaceholder', this.$i18n.locale);
    },
    hasPaymentAccountPopupCopy() {
      return Boolean(
        this.paymentAccountPopupWarningCopy ||
        this.paymentAccountPopupSubmitCopy ||
        this.paymentAccountPopupInputPlaceholderCopy
      );
    },
    showPaymentAccountPopupWarningIcon() {
      return !this.hasPaymentAccountPopupCopy;
    },
    paymentAccountPopupTitle() {
      if (this.hasOperatorList !== undefined) {
        return this.hasOperatorList
          ? this.$t('text_please_fill_payment_method2')
          : this.$t('text_please_fill_payment_method');
      }
      if (Array.isArray(this.operatorList)) {
        return this.operatorList.length
          ? this.$t('text_please_fill_payment_method2')
          : this.$t('text_please_fill_payment_method');
      }
      return 'Payment account';
    },
    paymentAccountPopupWarning() {
      if (this.paymentAccountPopupWarningCopy) {
        return this.paymentAccountPopupWarningCopy;
      }
      return '';
    },
    paymentAccountPopupSubmitText() {
      if (this.paymentAccountPopupSubmitCopy) {
        return this.paymentAccountPopupSubmitCopy;
      }
      if (this.$options.name === 'repayment') {
        return 'Submit';
      }
      return this.$t('text_confirm');
    },
    paymentAccountPopupInputPlaceholder() {
      if (this.paymentAccountPopupInputPlaceholderCopy) {
        return this.paymentAccountPopupInputPlaceholderCopy;
      }
      return this.$t('text_please_enter_your_actual_payment_account');
    },
  },
};
